import React, { createContext, useContext, useState } from "react";

const FooterContext = createContext();

export const useFooterContext = () => useContext(FooterContext);

export const FooterProvider = ({ children }) => {
  const [footerHeight, setFooterHeight] = useState(0);

  return (
    <FooterContext.Provider value={{ footerHeight, setFooterHeight }}>
      {children}
    </FooterContext.Provider>
  );
};
